import { render } from "./WarningGray.vue?vue&type=template&id=ae635950&scoped=true&ts=true"
import script from "./WarningGray.vue?vue&type=script&lang=ts"
export * from "./WarningGray.vue?vue&type=script&lang=ts"

import "./WarningGray.vue?vue&type=style&index=0&id=ae635950&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae635950"]])

export default __exports__